export default "__VITE_ASSET__3dc2354e__"